import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './styles/globals.css';

import { initCometChat } from './cometchat';

async function startApp() {
  try {
    await initCometChat();
    console.log("CometChat Initialized!");

    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch (error) {
    console.error("CometChat initialization failed:", error);
  }
}

startApp();